import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import "./PlanModal.css";

const PlanModal = ({
  show,
  onClose,
  plansData,
  onSelectAmount,
  onSelectPlanDescription,
}) => {
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const tabsContainerRef = useRef(null);

  useEffect(() => {
    if (plansData && plansData.length > 0) {
      setActiveTabIndex(0);
    }
  }, [plansData]);

  const scrollTabs = (direction) => {
    if (tabsContainerRef.current) {
      const scrollAmount = direction === "left" ? -200 : 200;
      tabsContainerRef.current.scrollBy({
        left: scrollAmount,
        behavior: "smooth",
      });
    }
  };

  return (
    <React.Fragment>
      {/* Tabs with scroll controls */}
      <div className="d-flex align-items-center mb-3">
        <button
          className="btn btn-sm btn-outline-secondary me-2"
          onClick={() => scrollTabs("left")}
          disabled={activeTabIndex === 0}
        >
          &lt;
        </button>

        <ul
          ref={tabsContainerRef}
          className="nav nav-tabs flex-nowrap overflow-auto hide-scrollbar flex-grow-1"
          style={{ scrollBehavior: "smooth" }}
        >
          {plansData.map((tab, index) => (
            <li className="nav-item" key={index}>
              <button
                className={`nav-link ${
                  activeTabIndex === index ? "active" : ""
                }`}
                onClick={() => setActiveTabIndex(index)}
                type="button"
              >
                {tab.tab_name}
              </button>
            </li>
          ))}
        </ul>

        <button
          className="btn btn-sm btn-outline-secondary ms-2"
          onClick={() => scrollTabs("right")}
          disabled={activeTabIndex === plansData.length - 1}
        >
          &gt;
        </button>
      </div>

      {/* Tab Content with fixed height and scroll */}
      <div
        className="plans-content"
        style={{ height: "400px", overflowY: "auto" }}
      >
        {plansData[activeTabIndex]?.data?.length > 0 ? (
          <div className="list-group">
            {plansData[activeTabIndex].data.map((plan, index) => (
              <div key={index} className="list-group-item">
                <div className="d-flex justify-content-between align-items-start">
                  <button
                    className="btn square-amount-button me-3"
                    onClick={() => {
                      onSelectAmount(plan.amount);
                      onSelectPlanDescription(plan.planDescription);
                    }}
                  >
                    ₹{plan.amount}
                  </button>
                  <div className="flex-grow-1">
                    <p className="mb-1">{plan.planDescription}</p>
                    {plan.validity && (
                      <small className="text-muted">
                        Validity: <strong>{plan.validity}</strong>
                      </small>
                    )}
                    {plan.dataBenefit && (
                      <small className="text-muted ms-3">
                        Data: <strong>{plan.dataBenefit}</strong>
                      </small>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p>No plans available for this category.</p>
        )}
      </div>
    </React.Fragment>
  );
};

PlanModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  plansData: PropTypes.array.isRequired,
  onSelectAmount: PropTypes.func.isRequired,
};

export default PlanModal;
